module.exports = __webpack_public_path__ + "public/fb982ea46bdbfca34f67e6ee83f28d30.svg";